import React, { useCallback, useEffect, useState } from "react";
import { FaArrowLeft, FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/axios";
import AreaPatrocinadoresAdm from "./areaPatrocinadoresAdm";
import AreaPatrocinadoresConteudoAdm from "./areaPatrocinadoresConteudoAdm";
import "./admPatrocinadoresList.css";
import "./admMaisDetalhes.css";

const AdmMaisDetalhes = () => {
  const navigate = useNavigate();
  const [patrocinadores, setPatrocinadores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleCarregaPatrocinadores = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const arrayP = await api.get("/patrocinador-mais-detalhes");
      const arrayPatrocinadores = (arrayP.data?.patrocinadores || []).map(
        (p) => {
          p.agenda_patrocinador = p?.usuario?.agendaParticipante
            ? p.usuario.agendaParticipante.filter((a) => {
                return a.agenda?.tipo === "reuniao_negocio";
              })
            : [];
          let quantidadeFutura = 0;
          let quantidadeRealizada = 0;
          let quantidadeNoShow = 0;
          p.agenda_patrocinador.forEach((ap) => {
            if (ap.agenda.status === "futura") {
              quantidadeFutura++;
            }
            if (ap.agenda.status === "entregue") {
              quantidadeRealizada++;
            }
            if (ap.agenda.status === "no_show") {
              quantidadeNoShow++;
            }
          });

          p.futuras = quantidadeFutura;
          p.entregues = quantidadeRealizada;
          p.noshow = quantidadeNoShow;

          return p;
        }
      );
      setPatrocinadores(arrayPatrocinadores);
    } catch (err) {
      console.error("Erro ao carregar mais detalhes:", err);
      setError("Erro ao carregar detalhes dos patrocinadores.");
      setPatrocinadores([]);
      toast.error(
        err?.response?.data?.mensagem ||
          "Erro ao carregar detalhes dos patrocinadores."
      );
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    handleCarregaPatrocinadores();
  }, [handleCarregaPatrocinadores]);

  return (
    <div className="apl-page apl-page--padded amd-page">
      <header className="apl-header" aria-label="Cabeçalho mais detalhes">
        <div className="apl-header-text">
          <h1>Mais detalhes</h1>
          <p>
            Acompanhe reuniões agendadas, entregues, no shows e o percentual de
            SLA por cota de patrocínio.
          </p>
        </div>

        <div className="apl-toolbar">
          <button
            type="button"
            className="apl-btn apl-btn--ghost"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft size={14} aria-hidden />
            Voltar
          </button>
        </div>
      </header>

      <div className="body-tela-adm amd-body" style={{ paddingBottom: 0 }}>
        {error ? (
          <div className="apl-alert" role="alert">
            {error}
          </div>
        ) : null}

        {isLoading ? (
          <div className="apl-card">
            <div className="apl-loading">
              <FaSpinner className="fa-spin" size={28} aria-hidden />
              <span>Carregando detalhes dos patrocinadores…</span>
            </div>
          </div>
        ) : (
          <>
            <AreaPatrocinadoresAdm
              patrocinadores={patrocinadores}
              cota="PREMIUM"
              id_cota={1}
            />
            <AreaPatrocinadoresAdm
              patrocinadores={patrocinadores}
              cota="ADVANCE"
              id_cota={3}
            />
            <AreaPatrocinadoresAdm
              patrocinadores={patrocinadores}
              cota="LITE"
              id_cota={[4, 6]}
            />
            <AreaPatrocinadoresConteudoAdm cota="COTA CONTEÚDO" id_cota={7} />
          </>
        )}
      </div>
    </div>
  );
};

export default AdmMaisDetalhes;
